export default __webpack_public_path__ + "static/media/digitalcard_person_membership-pass.c7a00feb.svg";